import styled from 'styled-components';

export default styled.a`
  color: ${({ theme }) => theme.menuItemColour};
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: 'Montserrat';
  font-weight: bold;
  font-size: 0.9rem;
  padding: 0.5rem;
  position: relative;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.menuItemHover};
  }

  &.active {
    color: ${({ theme }) => theme.menuItemActive};
  }
`;
